import {FeatureFlagsEnum} from '../../store/featureFlags/featureFlagsTypes';
import {AppRoutesPrefixesEnum} from '../appRoutesPrefixes';

/*
 * Props.
 */

export interface LegacySettingsRewriteRoute {
  legacyPath: string;
  newPath: string;
  featureFlag?: FeatureFlagsEnum;
}

interface LegacyRouteToNewRoute {
  legacyRoute: string;
  newRoute: string;
}

export type SettingsLegacyRewriteRouteFinder = (path: string | undefined) => string | undefined;

/*
 * App Store Routes.
 */

const appsRoutes: ReadonlyArray<LegacyRouteToNewRoute> = [
  {
    legacyRoute: 'integrations',
    newRoute: 'apps',
  },
  {
    legacyRoute: 'integrations/native',
    newRoute: 'apps',
  },
  {
    legacyRoute: 'integrations/native/edit/:integrationType/details',
    newRoute: 'apps/details/:integrationType/overview',
  },
  {
    legacyRoute: 'integrations/native/edit/:integrationType/settings',
    newRoute: 'apps/details/:integrationType/overview?open_configuration=true',
  },
];

const settingsAppsRoutes: ReadonlyArray<LegacySettingsRewriteRoute> = appsRoutes.map((details) => ({
  legacyPath: `/${AppRoutesPrefixesEnum.SETTINGS}/${details.legacyRoute}`,
  newPath: `/${AppRoutesPrefixesEnum.SETTINGS}/${details.newRoute}`,
  featureFlag: FeatureFlagsEnum.NEW_INTEGRATIONS_DISCOVERABILITY,
}));

/*
 * Union of routes.
 */

export const legacySettingsRewriteRoutes: ReadonlyArray<LegacySettingsRewriteRoute> = [...settingsAppsRoutes];
